<div class="w-full h-full flex items-center justify-center">
  <fun-overal-message *ngIf="step === 0 && !loading" [text]="initText" [image]="12" [btnList]="initBtnList"
    (btnEvent)="next()"></fun-overal-message>
  <app-mangopay-sca-validation *ngIf="step === 1 && !loading" [isOwner]="isOwner"
    [hasConsentGranted]="profileHasConsent" (finishEvent)="next()"></app-mangopay-sca-validation>
  <fun-overal-message *ngIf="step === 2 && !loading" [text]="finishText" [image]="12" [btnList]="initBtnList"
    (btnEvent)="continue()"></fun-overal-message>
  <div *ngIf="loading" class="pb-32"><fun-spinner></fun-spinner></div>
</div>